var viewer_caption_default = {
  "fontElementMap": "uoMM6",
  "imageCaption": "Zuehd"
};
export {
  viewer_caption_default as default
};
//# sourceMappingURL=viewer-caption-scss.js.map
